<template>
  <div class="share">

    <div class="jurisdiction">
      <div class="user">
        <div class="Tit">用户列表</div>
        <el-input placeholder="输入用户名搜索" clearable prefix-icon="el-icon-search" v-model="input1" @input="userChange()">
        </el-input>
        <div class="List">
          <ul id="now" style="display:none">
            <li v-for="(item,index) in searchList1" :key="index" @click="chooseUser(index,item)" :class="{choose:userIdx==index}">
              {{item.userName}}
            </li>
          </ul>
          <ul id="historyList" style="display:block">
            <li v-for="(item,index) in userList" :key="index" @click="chooseUser(index,item)" :class="{choose:userIdx==index}">
              {{item.userName}}
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="works">
          <div class="Tit">多维分析编辑权限(资源)</div>
          <el-input placeholder="输入关键字进行搜索" clearable class="filter" v-model="filterText1">
          </el-input>
          <div class="List">
            <el-tree show-checkbox :data="treeData" :props="defaultProps" icon-class="tree-icon el-icon-caret-right" :accordion="true" :highlight-current="true" :filter-node-method="filterNode1" @node-click="handleNodeClick" ref="tree1" @check-change="handleCheck1" @check="handleCheck1" node-key="id" :default-checked-keys="shareSource">
              <span class="custom-tree-node keywords_em" slot-scope="{ node, data }">
                <span v-if="!filterText1">{{data.label}}</span>
                <span v-if="filterText1" v-html="data.label.replace(new RegExp(filterText1,'g'),`<em>${filterText1}</em>`)"></span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="works">
          <div class="Tit">综合展现编辑权限(资源)</div>
          <el-input placeholder="输入关键字进行搜索" clearable class="filter" v-model="filterText2">
          </el-input>
          <div class="List">
            <el-tree show-checkbox :data="screenList" :props="defaultProps" icon-class="tree-icon el-icon-caret-right" :accordion="true" :highlight-current="true" :filter-node-method="filterNode2" @node-click="handleNodeClick2" ref="tree2" @check-change="handleCheck2" node-key="id" :default-checked-keys="shareScreen">
              <span class="custom-tree-node keywords_em" slot-scope="{ node, data }">
                <span v-if="!filterText2">{{data.label}}</span>
                <span v-if="filterText2" v-html="data.label.replace(new RegExp(filterText2,'g'),`<em>${filterText2}</em>`)"></span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="works">
          <div class="Tit">数据准备查看权限(数据)</div>
          <el-input placeholder="输入关键字进行搜索" clearable class="filter" v-model="filterText3">
          </el-input>
          <div class="List">
            <el-tree show-checkbox :data="tableList" :props="defaultProps" icon-class="tree-icon el-icon-caret-right" :accordion="true" :highlight-current="true" :filter-node-method="filterNode3" @node-click="handleNodeClick3" ref="tree3" @check-change="handleCheck3" node-key="id" :default-checked-keys="shareTable">
              <span class="custom-tree-node keywords_em" slot-scope="{ node, data }">
                <span v-if="!filterText3">{{data.label}}</span>
                <span v-if="filterText3" v-html="data.label.replace(new RegExp(filterText3,'g'),`<em>${filterText3}</em>`)"></span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="btn">
          <!-- <el-button type="primary" @click="saveShare()">确定</el-button> -->
          <el-button type="primary" @click="open">保存</el-button>
          <el-button type="info" @click="nosaveShare()">重置</el-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {
  //获取消息内容
  GetResourceList,
  CreateShare,
  GetDataSourceLists,
} from '@/assets/axios/share/share'
export default {
  data() {
    return {
      nodes1:[],
      ChildTable: [],
      tableList: [],
      dataSource: [],
      ShareSets: [],
      ShareViews: [],
      screenGroupBy: [],
      Child: [],
      shareTable:[],
      shareScreen: [],
      shareSource: [],
      allChecked: [],
      halfChecked: [],
      filterText1: "",
      filterText2: "",
      filterText3: "",
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      userIdx: 0,
      sourceIdx: -1,
      viewIdx: -1,
      screenIdx: -1,
      tableIdx:-1,
      userList: [],
      screenList: [],
      searchList1: [],
      searchList2: [],
      searchList3: [],
      searchList4: [],
      userName: "",//选中的用户名
      userId: "",//用户id
      sourceName: "",//选中的数据接入名
      viewName: "",//选中的多维分析名
      screenName: "",//选中的多维分析名
      tableName: "",//选中的多维分析名
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      defaultProps1: {
        children: 'children',
        label: 'label'
      },
      defaultProps2: {
        children: 'children',
        label: 'label'
      },
      defaultProps3: {
        children: 'children',
        label: 'label'
      },
    }
  },
  methods: {
    init() {
      this.getPageInfo();
      this.getTableInfo()
    },
    open() {
      if (!this.userId) {
        this.getMsg('请选择被分享用户！');
        return;
      }
      this.$confirm(`是否将已经勾选的资源权限共享给${this.userName}？`, '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '放弃分享'
      })
        .then(() => {
          this.handleCheck1()
          this.handleCheck2()
          this.handleCheck3()
          var data =
            [{
              ShareUserID: this.userId,// 被分享的用户
              DataSource: this.dataSource,
              DataSet: this.ShareSets,
              DataView: this.ShareViews,
              ScreenGroupBy: this.screenGroupBy,
              Screen: this.Child,
              DataTableSource: this.tableGroupBy,
              DataTableSharing: this.nodes1,
            }]
          CreateShare(data).then(res => {
            if (res.code === 200) {
              this.getPageInfo()
              // this.getMsg('权限分享成功！', 'success');
            }
          })
          this.$message({
            type: 'success',
            message: '权限分享成功！'
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: action === 'cancel'
              ? '取消分享'
              : '取消分享'
          })
        });
    },
    handleCheck1(data, checked, indeterminate, checkedData) {
      let nodes = this.$refs.tree1.getCheckedNodes().concat(this.$refs.tree1.getHalfCheckedNodes())//过滤出子节点，也就是不含children字段的节点数据
      let filterParent = nodes.filter(node => {
        return node.parent === undefined
      })
      this.dataSource = []
      this.ShareSets = []
      this.ShareViews = []
      for (var i = 0; i < filterParent.length; i++) {
        var parentList = {}
        var parentId = filterParent[i].id
        var parentLabel = filterParent[i].label
        parentList = {
          ShareSourceID: parentId,
          ShareSourceName: parentLabel,
        }
        this.dataSource.push(parentList)
        if (filterParent[i].children) {
          for (var j = 0; j < filterParent[i].children.length; j++) {
            for (var m = 0; m < nodes.length; m++) {
              if (filterParent[i].children[j].children && nodes[m].id == filterParent[i].children[j].id) {
                var middleList = {}
                var middleId = filterParent[i].children[j].id
                var middleLabel = filterParent[i].children[j].label
                middleList = {
                  ShareSetID: middleId,
                  ShareSetName: middleLabel,
                  ParentId: parentId,
                  // ParentName: parentLabel
                }
                this.ShareSets.push(middleList)

                for (var k = 0; k < filterParent[i].children[j].children.length; k++) {
                  var childList = {}
                  var childId = filterParent[i].children[j].children[k].id
                  var childLabel = filterParent[i].children[j].children[k].label
                  childList = {
                    ShareViewID: childId,
                    ShareViewName: childLabel,
                    ParentId: middleId,
                    // ParentName: middleLabel
                  }
                  this.ShareViews.push(childList)
                }
              }
            }
          }
        }
      }
      const s3 = new Set(this.ShareSets)
      this.ShareSets = [...s3]

    },
    handleCheck2(data, checked, indeterminate) {
      let nodes = this.$refs.tree2.getCheckedNodes().concat(this.$refs.tree2.getHalfCheckedNodes())//过滤出子节点，也就是不含children字段的节点数据
      let filterParent = nodes.filter(node => {
        return node.parent === undefined
      })
      this.screenGroupBy = []
      this.Child = []
      for (var i = 0; i < filterParent.length; i++) {
        var parentList = {}
        var parentId = filterParent[i].id
        var parentLabel = filterParent[i].label
        var ThumbNail = filterParent[i].thumbNail
        parentList = {
          Groupid: parentId,
          ScreenName: parentLabel,
          // ThumbNail: ThumbNail,
        }
        this.screenGroupBy.push(parentList)
        if (filterParent[i].children) {
          for (var j = 0; j < filterParent[i].children.length; j++) {
            for (var m = 0; m < nodes.length; m++) {
              if (nodes[m].id == filterParent[i].children[j].id) {
                var childList = {}
                var childId = filterParent[i].children[j].id
                var childLabel = filterParent[i].children[j].label
                var ThumbNail = filterParent[i].children[j].thumbNail
                var parent = filterParent[i].children[j].parent
                childList = {
                  Id: childId,
                  ScreenPageName: childLabel,
                  ParentId: parent,
                  // ThumbNail: ThumbNail,
                }
                this.Child.push(childList)
              }
            }
          }
        }
      }
      const s4 = new Set(this.Child)
      this.Child = [...s4]
      console.log(this.Child)
    },
    handleCheck3(data, checked, indeterminate) {
      let nodes = this.$refs.tree3.getCheckedNodes().concat(this.$refs.tree3.getHalfCheckedNodes())//过滤出子节点，也就是不含children字段的节点数据
      let filterParent = nodes.filter(node => {
        return node.tableType === undefined
      })
      let nodes1 = nodes.filter(node => {
        return node.children === undefined
      })
      console.log(nodes1)
      this.nodes1 = nodes1
      this.tableGroupBy = []
      this.ChildTable = []
      for (var i = 0; i < filterParent.length; i++) {
        var parentList = {}
        var parentId = filterParent[i].id
        var parentLabel = filterParent[i].label
        var ThumbNail = filterParent[i].thumbNail
        parentList = {
          ShareSourceID: parentId,
          ShareSourceName: parentLabel,
          // ThumbNail: ThumbNail,
        }
        this.tableGroupBy.push(parentList)
        if (filterParent[i].children) {
          for (var j = 0; j < filterParent[i].children.length; j++) {
            for (var m = 0; m < nodes1.length; m++) {
              if (nodes1[m].label == filterParent[i].children[j].label) {
                  var childList = {}
                  var childId = filterParent[i].children[j].id
                  var childLabel = filterParent[i].children[j].label
                  var ThumbNail = filterParent[i].children[j].thumbNail
                  // var parent = filterParent[i].children[j].parent
                  var parent = filterParent[i].id
                  childList = {
                    // Id: childId,
                    ShareTableName: childLabel,
                    ParentId: parent,
                    // ThumbNail: ThumbNail,
                  }
                  this.ChildTable.push(childList)

              }
            }
          }
        }
      }
      const s5 = new Set(this.ChildTable)
      this.ChildTable = [...s5]
    },
    getPageInfo() {
      GetResourceList().then(res => {
        if (res.code === 200) {
          this.userList = []
          this.treeData = []
          this.tableList = []
          this.screenList = []
          this.shareTable = []
          this.shareScreen = []
          this.shareSource = []
          for (var i = 0; i < res.data.userList.length; i++) {
            var userInfo = {}
            userInfo = {
              userId: res.data.userList[i].itemArray[0],
              userName: res.data.userList[i].itemArray[1],
            }
            this.userList.push(userInfo)
          }
          this.userId = this.userList[this.userIdx].userId
          this.userName = this.userList[this.userIdx].userName
          for (var i = 0; i < res.data.shareTable.length; i++) {
            if (this.userId == res.data.shareTable[i].shareUserID) {
              this.shareTable = res.data.shareTable[i].shareTableID
              console.log(this.shareTable)
            }
          }
          for (var i = 0; i < res.data.shareScreen.length; i++) {
            if (this.userId == res.data.shareScreen[i].shareUserID) {
              this.shareScreen = res.data.shareScreen[i].shareScreenIDs
            }
          }
          for (var i = 0; i < res.data.shareSource.length; i++) {
            if (this.userId == res.data.shareSource[i].shareUserID) {
              this.shareSource = res.data.shareSource[i].shareViewIDs
              console.log(this.shareSource)

            }
          }
          var arr1 = res.data.sourceList.map(item => {
            if (item.setList.length > 0) {
              var setListAll = []
              for (var i = 0; i < item.setList.length; i++) {
                var setList = {}
                if (item.setList[i].viewList.length == 0) {
                  setList.id = item.setList[i].setID
                  setList.label = item.setList[i].setName
                  setList.parent = item.sourceName
                  setList = {
                    id: setList.id,
                    label: setList.label,
                    parent: setList.parent,
                    disabled: true,
                  }
                  setListAll.push(setList)
                } else if (item.setList[i].viewList.length > 0) {
                  var viewListAll = []
                  for (var j = 0; j < item.setList[i].viewList.length; j++) {
                    var viewList = {}
                    setList.id = item.setList[i].setID
                    setList.label = item.setList[i].setName
                    setList.parent = item.sourceName
                    viewList.id = item.setList[i].viewList[j].viewID;
                    viewList.label = item.setList[i].viewList[j].viewName;
                    viewList = {
                      id: viewList.id,
                      label: viewList.label,
                      parent: setList.label,
                    }
                    viewListAll.push(viewList)
                  }
                  setList = {
                    id: setList.id,
                    label: setList.label,
                    children: viewListAll,
                    parent: setList.parent,
                  }
                  setListAll.push(setList)
                }
              }
              return {
                id: item.groupID,
                label: item.sourceName,
                children: setListAll,
              }
            } else {
              return {
                id: item.groupID,
                label: item.sourceName,
                disabled: true,
              }
            }
          })
          this.treeData = arr1
          console.log(this.treeData)
          var arr2 = res.data.screenList.map(item => {
            if (item.child.length > 0) {
              var childAll = []
              for (var i = 0; i < item.child.length; i++) {
                var child = {}
                child.id = item.child[i].id
                child.label = item.child[i].screenPageName
                child.thumbNail = item.child[i].thumbNail
                child.parent = item.groupid
                child = {
                  id: child.id,
                  label: child.label,
                  thumbNail: child.thumbNail,
                  parent: child.parent
                }
                childAll.push(child)
              }
              return {
                id: item.groupid,
                label: item.screenName,
                children: childAll,
                thumbNail: item.thumbNail
              }
            } else {
              return {
                id: item.groupid,
                label: item.screenName,
                thumbNail: item.thumbNail
              }
            }
          })
          this.screenList = arr2;
        }
      }),
      GetDataSourceLists().then(res => {
        if (res.code === 200) {
          this.tableList = res.data
        }
      })
    },
    getTableInfo() {
      GetDataSourceLists().then(res => {
        if (res.code === 200) {
          this.tableList = res.data
        }
      })
    },
    userChange() {
      var historyList = document.getElementById("historyList");
      var now = document.getElementById("now");
      historyList.style.display = "none";
      now.style.display = "block";
      if (this.input1) {
        this.userIdx = 0;
        this.searchList1 = [];
        for (var i = 0; i < this.userList.length; i++) {
          if (this.userList[i].userName.indexOf(this.input1) != -1) {
            this.searchList1.push(this.userList[i]);
          }
        }
      } else {
        this.userName = ""
        this.searchList1 = [];
        historyList.style.display = "block";
        now.style.display = "none";
        this.userIdx = 0;
      }
    },
    filterNode1(value, data, node) {
      // 如果共有四级菜单
      if (!value) return true
      let ifOne = data.label.indexOf(value) !== -1
      let ifTwo = node.parent && node.parent.data && node.parent.data.label && (node.parent.data.label.indexOf(value) !== -1)
      let ifThree = node.parent && node.parent.parent && node.parent.parent.data && node.parent.parent.data.label && (node.parent.parent.data.label.indexOf(value) !== -1)
      let ifFour = node.parent && node.parent.parent && node.parent.parent.parent && node.parent.parent.parent.data && node.parent.parent.parent.data.label && (node.parent.parent.parent.data.label.indexOf(value) !== -1)
      let resultOne = false
      let resultTwo = false
      let resultThree = false
      let resultFore = false
      if (node.level === 1) {
        resultOne = ifOne
      } else if (node.level === 2) {
        resultTwo = ifOne || ifTwo
      } else if (node.level === 3) {
        resultThree = ifOne || ifTwo || ifThree
      } else if (node.level === 4) {
        resultFore = ifOne || ifTwo || ifThree || ifFour
      }
      return resultOne || resultTwo || resultThree || resultFore
    },
    filterNode2(value, data, node) {
      // 如果共有四级菜单
      if (!value) return true
      let ifOne = data.label.indexOf(value) !== -1
      let ifTwo = node.parent && node.parent.data && node.parent.data.label && (node.parent.data.label.indexOf(value) !== -1)
      let ifThree = node.parent && node.parent.parent && node.parent.parent.data && node.parent.parent.data.label && (node.parent.parent.data.label.indexOf(value) !== -1)
      let ifFour = node.parent && node.parent.parent && node.parent.parent.parent && node.parent.parent.parent.data && node.parent.parent.parent.data.label && (node.parent.parent.parent.data.label.indexOf(value) !== -1)
      let resultOne = false
      let resultTwo = false
      let resultThree = false
      let resultFore = false
      if (node.level === 1) {
        resultOne = ifOne
      } else if (node.level === 2) {
        resultTwo = ifOne || ifTwo
      } else if (node.level === 3) {
        resultThree = ifOne || ifTwo || ifThree
      } else if (node.level === 4) {
        resultFore = ifOne || ifTwo || ifThree || ifFour
      }
      return resultOne || resultTwo || resultThree || resultFore
    },
    filterNode3(value, data, node) {
      // 如果共有四级菜单
      if (!value) return true
      let ifOne = data.label.indexOf(value) !== -1
      let ifTwo = node.parent && node.parent.data && node.parent.data.label && (node.parent.data.label.indexOf(value) !== -1)
      let ifThree = node.parent && node.parent.parent && node.parent.parent.data && node.parent.parent.data.label && (node.parent.parent.data.label.indexOf(value) !== -1)
      let ifFour = node.parent && node.parent.parent && node.parent.parent.parent && node.parent.parent.parent.data && node.parent.parent.parent.data.label && (node.parent.parent.parent.data.label.indexOf(value) !== -1)
      let resultOne = false
      let resultTwo = false
      let resultThree = false
      let resultFore = false
      if (node.level === 1) {
        resultOne = ifOne
      } else if (node.level === 2) {
        resultTwo = ifOne || ifTwo
      } else if (node.level === 3) {
        resultThree = ifOne || ifTwo || ifThree
      } else if (node.level === 4) {
        resultFore = ifOne || ifTwo || ifThree || ifFour
      }
      return resultOne || resultTwo || resultThree || resultFore
    },
    chooseUser(index, item) {
      this.userIdx = index
      this.userName = item.userName;
    },
    chooseSource(index, item) {
      this.sourceIdx = index
      this.sourceName = item
    },
    chooseView(index, item) {
      this.viewIdx = index
      this.viewName = item
    },
    chooseScreen(index, item) {
      this.screenIdx = index
      this.screenName = item
    },
    chooseTable(index, item) {
      this.tableIdx = index
      this.tableName = item
    },
    handleNodeClick(viewList) {
      this.viewName = "";
      if (!("children" in viewList)) {
        this.viewName = viewList.label
      }
    },
    handleNodeClick2(screenList) {
      this.screenName = "";
      if (!("children" in screenList)) {
        this.screenName = screenList.label
      }
    },
    handleNodeClick3(tableList) {
      this.tableName = "";
      if (!("children" in tableList)) {
        this.tableName = tableList.label
      }
    },
    viewBlur() {
      this.viewName = "";
    },
    saveShare() {
      if (!this.userName) {
        this.getMsg('请选择被分享用户！');
        return;
      }
      this.handleCheck1()
      this.handleCheck2()
      this.handleCheck3()
      var data =
        [{
          ShareUserID: this.userId,// 被分享的用户
          DataSource: this.dataSource,
          DataSet: this.ShareSets,
          DataView: this.ShareViews,
          ScreenGroupBy: this.screenGroupBy,
          Screen: this.Child,
        }]
      CreateShare(data).then(res => {
        if (res.code === 200) {
          this.getPageInfo()
          this.getMsg('权限分享成功！', 'success');
        }
      })

    },
    nosaveShare() {
      location.reload();

    }
  },
  watch: {
    filterText1(val) {
      this.$refs.tree1.filter(val)
    },
    filterText2(val) {
      this.$refs.tree2.filter(val)
    },
    filterText3(val) {
      this.$refs.tree3.filter(val)
    },
    userIdx() {
      this.getPageInfo()
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="less">
.jurisdiction {
  width: 100%;
  height: 650px;
  padding: 1.5%;
  background: #eaebf7;
  border-radius: 10px;
  .user,
  .works {
    width: 15%;
    height: 600px;
    float: left;
    background: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    overflow-y: scroll;
    position: relative;

    .Tit {
      font-size: 20px;
      margin-bottom: 20px;
    }
    .List {
      em {
        // color: #f7b620;
        font-style: normal;
        background: #fee972;
      }
      ul {
        height: 100%;
        padding: 10px 0 10px;
        li {
          line-height: 35px;
          padding: 0 10% 0;
          border-radius: 1px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: -3px;

          .el-checkbox__label {
            width: 205px;
            color: #000;
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: -3px;
          }
        }
        li:hover {
          background: #7f93b9;
          color: #fff;
          transition: background-color 0.1s linear;
          .el-checkbox__label {
            color: #fff;
            font-size: 16px;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            border-color: #002774;
          }
        }
        .choose {
          background: #7f93b9;
          color: #fff;
          .el-checkbox__label {
            // color: #fff;
            font-size: 16px;
          }
        }
      }
    }
  }
  .works {
    width: 20%;
    .el-tree {
      margin-top: 10px;
      span:hover {
        color: #fff;
      }
    }

    .el-tree-node__label {
      font-size: 16px;
      color: #000;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      overflow: hidden;
      height: 100%;
      line-height: 35px;
    }
    .el-tree-node__content:hover {
      background: #7f93b9;
      .el-tree-node__label {
        color: #fff;
      }
      em {
        color: #000;
      }
      span {
        color: #fff;
      }
      .el-tree-node__expand-icon.is-leaf {
        color: transparent;
        cursor: default;
      }
    }
    // .el-tree-node__content:visited {
    //   background: #7f93b9;
    //   .el-tree-node__label {
    //     color: #fff;
    //   }
    // }
    .el-tree-node__content {
      height: 35px;
    }
    // .el-tree-node:focus > .el-tree-node__content {
    //   background-color: #7f93b9;
    //   .el-tree-node__label {
    //     color: #fff;
    //   }
    // }
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      // background: #7f93b9;
      .el-tree-node__label {
        color: #fff;
      }
    }
  }
  .user::-webkit-scrollbar,
  .works::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .user::-webkit-scrollbar-track,
  .works::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  /*定义滑块 内阴影+圆角*/
  .user::-webkit-scrollbar-thumb,
  .works::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }
  .right {
    width: 83%;
    height: 100%;
    background: #fff;
    border-radius: 10px;
    float: right;
    position: relative;
    .btn {
      // width: 150px;
      height: 40px;
      position: absolute;
      right: 30px;
      bottom: 30px;
    }
  }
}
.share {
  height: 100%;
  padding: 20px;
}
</style>